import { hasPermission } from '@/hooks/useBackendMenu'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { CompensacaoDia, compensacaoFolgas } from 'service/api'
import { toast } from 'sonner'
import FormNovaCompensacaoFeriado from '../forms/NovaCompensacaoFeriado'
import { useDigitacaoContext } from '../pages/useDigitacaoContext'
import { useUpdateDigitacaoQueryData } from '../pages/useDigitacaoData'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

export default function DetalhesCompensacaoFolga() {
    const { mutate } = compensacaoFolgas.mutations.useSoftDelete()
    const { mutateAsync } = compensacaoFolgas.mutations.useUpdate()
    const navigate = useNavigate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { id } = useParams()
    const { data, getFuncionarioNome } = useDigitacaoContext()

    const compensacao = data.find(
        ({ compensacao }) => compensacao?.id === Number(id),
    )?.compensacao

    const funcionarioPodeAjustar = funcionarioPodeSolicitarAjustes()
    const [excluindo, setExcluindo] = useState(false)

    if (!compensacao) return null

    const referencia = `${getFuncionarioNome(compensacao.funcionarioId)} · ${dayjs.utc(compensacao.dataFeriado).format('DD/MM/YYYY')}`

    const podeExcluir =
        hasPermission(['update', 'CompensaçãoDeFolgas']) ||
        funcionarioPodeAjustar

    const handleExcluir = ({ motivo }: { motivo: string }) => {
        mutate({ ...compensacao, motivo } as any, {
            onSuccess: async () => {
                setQueryData('COMPENSACAO_FERIADO', compensacao, true)
                toast.success('Compensação excluída com sucesso')
                navigate(-1)
            },
            onError: e => {
                toast.error(e.message)
            },
        })
    }

    const handleSubmit: SubmitHandler<CompensacaoDia> = data =>
        mutateAsync(
            {
                ...data,
                dataCompensacao: dayjs(data.dataCompensacao).toDate(),
                dataFeriado: dayjs(data.dataFeriado).toDate(),
            },
            {
                onSuccess: res => {
                    setQueryData('COMPENSACAO_FERIADO', compensacao, true)
                    setQueryData('COMPENSACAO_FERIADO', res)
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            disableFields={!hasPermission(['update', 'CompensaçãoDeFolgas'])}
            defaultValues={{ ...compensacao, statusAprovacao: 'APROVADO' }}
            onSubmit={
                hasPermission(['create', 'CompensaçãoDeFolgas'])
                    ? handleSubmit
                    : undefined
            }
        >
            <Dialog.Title action="Detalhes da compensação de folga">
                {referencia}
            </Dialog.Title>
            <Dialog.Content>
                <FormNovaCompensacaoFeriado labelDataOrigem="Data da folga" />
                <Dialog.Content.Footer />
                <ConfirmarExclusao
                    width="2xl"
                    open={excluindo}
                    onClose={() => setExcluindo(false)}
                    exigirMotivo
                    onConfirm={({ motivo }) =>
                        handleExcluir({ motivo: motivo! })
                    }
                    title="Tem certeza que deseja excluir a compensação de folga?"
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                {podeExcluir && (
                    <Dialog.Actions.PrimaryButton
                        color="error"
                        data-testid="dialog-delete-button"
                        onClick={() => setExcluindo(true)}
                    >
                        Excluir
                    </Dialog.Actions.PrimaryButton>
                )}
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
